import React from 'react';
import { Box, Button, Collapse } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HistoryIcon from '@material-ui/icons/History';
import { useTranslate } from 'react-admin';
import { useDispatch } from 'react-redux';
import { selectAnc } from '../../redux/actions/ancs';
import { CRM_COLORS } from '../../theme/crmColors';

const actionStyle = { whiteSpace: 'nowrap' as const, flexShrink: 0, height: 36 };
const actionOpenStyle = {
    ...actionStyle,
    backgroundColor: CRM_COLORS.status.info.background,
    borderColor: CRM_COLORS.status.info.background,
    color: CRM_COLORS.primary,
};

interface Props {
    record: any;
    formsOpen: boolean;
    onToggleForms: () => void;
}

/** "Historique" opens the history panel, as clicking the card does; "Formulaires" unfolds the forms of the card. */
const InstallationCardActions = ({ record, formsOpen, onToggleForms }: Props) => {
    const t = useTranslate();
    const dispatch = useDispatch();

    return (
        <>
            <Button
                size='small'
                variant='outlined'
                startIcon={<HistoryIcon />}
                style={actionStyle}
                onClick={(event) => {
                    event.stopPropagation();
                    dispatch(selectAnc(record));
                }}
            >
                {t('app.ancsV2.actions.history')}
            </Button>
            <Button
                size='small'
                variant='outlined'
                aria-expanded={formsOpen}
                endIcon={<ExpandMoreIcon style={{ transform: formsOpen ? 'rotate(180deg)' : 'none' }} />}
                style={formsOpen ? actionOpenStyle : actionStyle}
                onClick={(event) => {
                    event.stopPropagation();
                    onToggleForms();
                }}
            >
                {t('app.ancsV2.actions.forms')}
            </Button>
        </>
    );
};

/** The forms under a card. They load when unfolded, and reading them must not open the history panel behind them. */
export const InstallationCardForms = ({ open, children }: { open: boolean; children: React.ReactNode }) => (
    <Collapse in={open} mountOnEnter unmountOnExit>
        <Box onClick={(event) => event.stopPropagation()} style={{ cursor: 'default' }}>
            {children}
        </Box>
    </Collapse>
);

export default InstallationCardActions;
